<template>
    <div class="topbar-container">
        <div class="scrollbar-container">
            <div class="warning-container bh bc">
                <div class="c_999 fz_24 topText">以下信息仅供交管局查询，我们将严格保密</div>
            </div>
            <validation-observer v-slot="{ invalid }" ref="form">
                <div class="info">
                    <div class="add-container bh bc border-bottom" @click="setMaskHidden(true)">
                        <div class="img bg-contain ico-poto"></div>
                        <div class="fz_30">拍照上传图片</div>
                    </div>
                    <validation-provider
                        :rules="{required: { allowFalse: false } }"
                        :customMessages="{required:'请输入正确的车牌号码'}"
                    >
                        <input type="hidden" v-model="isCarNumberValid" />
                    </validation-provider>
                    <validation-provider rules="required">
                        <License
                            ref="carNumber"
                            v-model="formData.carNumber"
                            @verifyChange="onLicenseVerifyChange"
                            class="border-bottom carNumber"
                        ></License>
                    </validation-provider>
                    <validation-provider
                        name="车身驾号"
                        :rules="`${verifyData.carCode ? 'required' : ''}|alpha_num|min:6|max:18`"
                        v-slot="{ errors}"
                    >
                        <van-field
                            v-model="formData.carCode"
                            clearable
                            input-align="right"
                            maxlength="18"
                            placeholder="请输入车身驾号"
                            class="border-bottom otherNum"
                        >
                            <div
                                slot="label"
                                class="bh bstart fz_30 c_333"
                                @click="onShowImg('./img/carCode.png')"
                            >
                                <span>车身驾号</span>
                                <van-icon name="warning-o" class="c_red" />
                            </div>
                            <zb-warning slot="right-icon" :message="errors[0]" />
                        </van-field>
                    </validation-provider>
                    <validation-provider
                        name="发动机号"
                        :rules="`${verifyData.carDriveNumber ? 'required' : ''}|alpha_num|min:6|max:14`"
                        v-slot="{ errors}"
                    >
                        <van-field
                            v-model="formData.carDriveNumber"
                            clearable
                            input-align="right"
                            maxlength="14"
                            placeholder="请输入发动机号"
                            class="otherNum"
                        >
                            <div
                                slot="label"
                                class="bh bstart fz_30 c_333"
                                @click="onShowImg('./img/carDriveNumber.png')"
                            >
                                发动机号
                                <van-icon name="warning-o" class="c_red" />
                            </div>
                            <zb-warning slot="right-icon" :message="errors[0]" />
                        </van-field>
                    </validation-provider>
                </div>
                <div class="agreement-wrap bh bc c_666 fz_24">
                    <validation-provider
                        :rules="{ required: { allowFalse: false } }"
                        :customMessages="{required:'请阅读并同意用户协议'}"
                    >
                        <van-checkbox v-model="checked">
                            <div class="fz_24">
                                已阅读并同意
                                <span
                                    class="c_warning"
                                    @click.stop="go('DealInfo',{data:'serviceAgreement2',title:'用户协议'})"
                                >用户协议</span> 和
                                <span
                                    class="c_warning"
                                    @click.stop="go('DealInfo',{data:'privacyPolicy2',title:'平台隐私政策'})"
                                >平台隐私政策</span>
                            </div>
                        </van-checkbox>
                    </validation-provider>
                </div>
                <div class="bh bc">
                    <van-button
                        :class="getBtnCls(invalid)"
                        class="btn btn-goodbuy"
                        @click="onSaveClick"
                    >保存并查询</van-button>
                </div>
            </validation-observer>
            <div class="bottom-btn bh bc">
                <div v-for="(item,index) in btnList" :key="index" class="b1 btn-wrap">
                    <div class="item bv bc c_666">
                        <div class="img bg-contain" :class="item.ico"></div>
                        <div class="title fz_24">{{item.name}}</div>
                        <div class="grey fz_24">{{item.text}}</div>
                    </div>
                </div>
            </div>
        </div>
        <van-overlay class="dialog" :show="maskFlag" @click="setMaskHidden(false)">
            <div class="bh bc dialog-container">
                <div class="dialog-wrap r10" @click.stop>
                    <div class="fz_34">拍照识别说明</div>
                    <div class="dialog-text c_999 fz_28 tl">请对准行驶证正面拍照上传，拍照时确保图像清晰，避免反光影响，以提高识别的正确率。</div>
                    <div class="dialog-box img-card bg-contain"></div>
                    <van-button class="btn btn-goodbuy" v-on:click.native="onUpClick">拍照上传</van-button>
                    <div class="ico-container" @click="setMaskHidden(false)">
                        <div class="bg-contain ico-maskClose"></div>
                    </div>
                </div>
            </div>
        </van-overlay>
        <DialogImg ref="dialogImg" :data="imgList"></DialogImg>
    </div>
</template>
<script>
import { user } from "@/mixin/user";
import License from "@/components/input/License";
import { checkNum, ocr } from "@/api/break";
import { addCar } from "@/api/break";
import { mixinBreak } from "@/mixin/break";
import { mixinValid } from "@/mixin/valid";
import { cuImage } from "@/utils/bridge";
import DialogImg from "@/components/dialog/Img";
import util from "@/utils/index";

export default {
    mixins: [user, mixinBreak, mixinValid],
    name: "BreakCarEdit",
    components: { License, DialogImg },
    data() {
        return {
            checked: false,
            imgList: [],
            maskFlag: false,
            formData: {
                carNumber: "",
                carCode: "",
                carDriveNumber: ""
            },
            // 后端返回的车牌校验规则
            checkData: {},
            // 动态校验规则
            verifyData: {
                carCode: true,
                carDriveNumber: true
            },
            // 车牌号是否可用
            isCarNumberValid: false,
            // 校验名称
            valid: {
                carCode: "车身驾号",
                carDriveNumber: "发动机号"
            },
            btnList: [
                {
                    name: "最快两小时",
                    text: "极速办理",
                    ico: "ico-fast",
                    go: ""
                },
                {
                    name: "官方大数据",
                    text: "及时稳定",
                    ico: "ico-bigdata",
                    go: ""
                },
                {
                    name: "信息云加密",
                    text: "隐私保护",
                    ico: "ico-lock",
                    go: ""
                }
            ],
            // 微信原生功能配置
            wx: {}
        };
    },
    watch: {
        checkData(v) {
            // vinLen 车架号长度 0 不需要 6车架号后6位 99全部
            this.verifyData.carCode = v.vinLen != 0;
            // engineNoLen 发动机号 0 不需要 6车架号后6位 99全部
            this.verifyData.carDriveNumber = v.engineNoLen != 0;
        }
    },
    methods: {
        onShowImg(v) {
            this.imgList = [v];
            this.$refs.dialogImg.onShowImg(0);
        },
        userLoginend() {
            // 测试环境处理
            if (this.$store.state.isDev) {
                this.formData = {
                    carNumber: "粤BL61Q9",
                    carCode: "036053",
                    carDriveNumber: "004179"
                };
            }
        },
        onSaveClick() {
            const me = this;
            me.validForm().then(() => {
                addCar(me.formData).then(res => {
                    // 刷新车辆列表，避免用户不支付时数据不更新
                    // 取消支付或者从支付页面返回
                    me.$store.dispatch("illegal/carList", true);
                    me.getBreakList(
                        { id: res.data, name: me.formData.carNumber },
                        true
                    );
                });
            });
        },
        onLicenseVerifyChange(is) {
            const me = this;
            me.isCarNumberValid = false;
            if (is) {
                checkNum(me.formData.carNumber).then(res => {
                    if (res.data.queriable) {
                        me.isCarNumberValid = true;
                        me.checkData = res.data;
                    } else {
                        me.toast.fail("暂不支持该车牌的违章信息查询");
                    }
                });
            }
        },
        setMaskHidden(v = false) {
            this.maskFlag = v;
        },
        onUpClick() {
            cuImage(this.wx).then(res => {
                const me = this;
                me.maskFlag = false;
                ocr(res).then(res => {
                    const data = res.data.words_result;
                    let is = false,
                        carNumber,
                        carCode,
                        carDriveNumber;
                    if (!util.objectIsEmpty(data)) {
                        carNumber = data["号牌号码"].words;
                        carCode = data["车辆识别代号"].words;
                        carDriveNumber = data["发动机号码"].words;
                        const regex = /[A-Za-z0-9]+$/;
                        // 验证识别是否成功
                        is =
                            me.$refs.carNumber.validLicense(carNumber) &&
                            util.regexVerify(regex, carCode) &&
                            util.regexVerify(regex, carDriveNumber);
                    }
                    if (is) {
                        me.formData = {
                            carNumber: carNumber,
                            carCode: carCode,
                            carDriveNumber: carDriveNumber
                        };
                    } else {
                        me.toast.fail("识别失败，请上传清晰完整的行驶证！");
                    }
                });
            });
        }
    }
};
</script>
<style scoped lang="scss">
@include img-list("~@/assets/imges/break/", "card");
.btn-goodbuy {
    margin-top: 60px;
    width: 510px;
    height: 76px;
}
/deep/ .van-cell {
    padding: 50px 0;
}
.scrollbar-container {
    @include placeholder($font-size: 28px, $color: #999, $text-align: right);
    background: #f1f2f3;

    .info {
        background: #fff;
        padding: 0px 40px;
        .add-container {
            height: 140px;
            .ico-poto {
                width: 78px;
                height: 59px;
                margin-right: 21px;
            }
        }
        .carNumber {
            padding: 30px 0;
        }
        .otherNum {
            /deep/ .van-field__label {
                width: 200px;
            }
        }
    }

    .border-bottom {
        &:after {
            width: 100%;
            border-color: #dcdcdc;
        }
    }
    .agreement-wrap {
        padding-top: 60px;
    }
    .bottom-btn {
        padding: 60px 30px 70px 30px;
        .btn-wrap {
            .img {
                padding-bottom: 24px;
                width: 66px;
                height: 66px;
            }
        }
    }
}

.dialog {
    .dialog-container {
        height: 100%;
        padding: 0 55px;
    }
    .dialog-wrap {
        position: relative;
        background: #fff;
        padding: 60px 55px;
        .dialog-text {
            padding: 38px 0 30px 10px;
        }
        .dialog-box {
            height: 360px;
        }
        .ico-container {
            position: absolute;
            top: 0;
            right: 0;
            padding: 24px;
            .ico-maskClose {
                width: 20px;
                height: 20px;
            }
        }
    }
}
</style>
